import plugin from './register-plugin.js';

class TopdkInfodialog {
    constructor(element, options) {
        this.$element = $(element);
        this.options = options;
        this.target = null;
        this.handleViewPortHeightChange = () => {
            this.$dialog.css('top', $(this.target).offset().top - this.$dialog.dialogTopDistanceFromTarget);
        };
        this.init();
    }

    init() {
        let that = this;
        // On some mobile devices, the activated keyboard is changing viewport size and to handle that we ned to
        // calculate the distance from target (input field) to dialog box (the help bubble)

        this.$dialog = $('<div class="dialog" />')
            .data('open', false)
            .on({
                click: function (e) {
                    $(that.target).trigger('focus.dialog');
                    e.stopPropagation();
                    that.$dialog.data('clicked', false);
                },
                mousedown: function () {
                    that.$dialog.data('clicked', true);
                }
            });

        this.$element.on({
            showDialog: function (e) {
                that.target = e.target || e.srcElement;
                // If target is last item in row, move target to first item
                if ($(that.target).hasClass('item-last')) {
                    that.target = $(that.target).prev('li');
                }
                if (that.$dialog.data('open') && that.$dialog.data('clicked')) {
                    return;
                }

                if (that.$dialog.data('open')) {
                    if (that.permissionToHideDialog()) {
                        $.when(that.hideDialog()).done(function () {
                            that.showDialog(that.target);
                        });
                    }
                } else {
                    that.showDialog(that.target);
                }
            },
            hideDialog: function () {
                if (that.permissionToHideDialog()) {
                    that.hideDialog();
                }
            }
        });

        this.$element.on('click', '.CheckBox-more', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let dataAttr = $(this).parent().prev().attr('data-info-teaser');
            if (typeof dataAttr !== typeof undefined && dataAttr !== false && dataAttr.length > 0) {
                that.$dialog.data('target', $(this).parent().prev().attr('id'));
                $(this).data('direction', 'pos-top');
                $(this).trigger('showDialog');
            }
        });

        this.$element.on('focus, click', 'input:checkbox, input:radio', function (e) {
            that.hideDialog();
            let dataAttr = $(this).attr('data-info-teaser'),
                required = $(this).attr('data-info-required'),
                windowWidth = $(window).width();
            if (typeof dataAttr !== typeof undefined && dataAttr !== false && dataAttr.length > 0) {
                let dataGrouped = $(this).attr('data-grouped');
                let triggerTarget;
                if (typeof dataGrouped !== typeof undefined && dataGrouped !== false && dataGrouped.length > 0) {
                    // because this group may be cloned, do not use a div id as selector since it would be repeated in the document
                    triggerTarget = $(this).parents('div').first();
                } else {
                    triggerTarget = $(this).parent();
                }
                if ($(this).is(':checkbox') && $(this).next().is('label')) {
                    triggerTarget = null;
                    //! :checked since we are before the change (is about to be checked
                    if (!$(this).is(':checked')) {
                        triggerTarget = $(this).next().find('.CheckBox-more');
                    }
                }

                if (triggerTarget && triggerTarget.length > 0) {
                    that.$dialog.data('target', $(this).attr('id'));
                    if (triggerTarget.length === 0 && $(this).parent('.input-list').length > 0) {
                        triggerTarget = $(this).parent('.input-list');
                    }
                    if (required || ($(this).is(':checkbox') && windowWidth > 767) || $(this).is(':radio')) {
                        triggerTarget.trigger('showDialog');
                    }
                    e.stopPropagation();
                }
            }
        });

        this.$element.on('focus', 'input:text, input[type=number], input[type=email], input[type=tel], input[type="date"], textarea', function () {
            let dataAttr = $(this).attr('data-info-teaser');

            if (typeof dataAttr !== typeof undefined && dataAttr !== false && dataAttr.length > 0) {
                that.$dialog.data('target', $(this).attr('id'));
                $(this).trigger('showDialog');
            }
        });

        this.$element.on('mouseenter', '.field-upload', function () {
            let dataAttr = $(this).attr('data-info-teaser');
            if (typeof dataAttr !== typeof undefined && dataAttr !== false && dataAttr.length > 0) {
                that.$dialog.data('target', $(this).attr('id'));
                $(this).trigger('showDialog');
            }
        });

        $(document).on('click', '', function (e) {
            if (that.$dialog.data('open') && that.$dialog.hasClass('has-close')) {
                that.$dialog.data('clicked', false);
                // that.$dialog.data('target', ''); // FAY: removed to avoid issue
                let dataAttr = $(e.target || e.srcElement).attr('data-info-teaser');
                if (typeof dataAttr === typeof undefined || dataAttr === false || dataAttr.length === 0) {
                    that.hideDialog();
                }
            }
        });

        // FAY: added to support data-info-teaser
        this.$element.on('click', '.hasInfodialog', function (e) {
            e.stopPropagation();
            let dataAttr = $(this).attr('data-info-teaser');
            if (typeof dataAttr !== typeof undefined && dataAttr !== false && dataAttr.length > 0) {
                that.$dialog.data('target', $(this).attr('id'));
                $(this).trigger('showDialog');
            }
        });
    }

    showDialog(dialogTarget) {
        let content,
            size,
            callback;

        this.target = $(dialogTarget);
        content = this.$dialog.data('target') ? this.getContent($('#' + this.$dialog.data('target'))) : this.getContent(this.target);
        size = this.target.data('size') || 'small';
        /* eslint-disable new-cap */
        callback = $.Deferred();
        this.$dialog
            .removeClass('pos-left pos-right small large pos-top pos-bottom')
            .addClass(size)
            .html(content)
            .data('open', true)
            .data('forid', this.target.attr('id'));
        if (this.options.errorStyling) {
            if (this.target.hasClass('error')) {
                this.$dialog.addClass('error');
            } else {
                this.$dialog.removeClass('error');
            }
        }

        // Can only get width/position after the dialog is in the DOM.
        // The dialog is placed inside the container, to make sure its position does not change when the browser window is resized.
        $('body').append(this.$dialog);
        this.getDialogPosition(callback);
        this.$dialog.dialogTopDistanceFromTarget = this.target.offset().top - this.$dialog.offset().top;
        return callback.promise();
    }

    hideDialog() {
        let that = this,
            callback = $.Deferred();
        this.$dialog.stop(true, true).fadeOut('fast', function () {
            // When dialog is hidden, we need to pick of the handleViewPortHeightChange event from the resize event stack
            $(window).off('resize', this.handleViewPortHeightChange);
            that.$dialog
                .detach()
                .data('open', false)
                .off('click.info-more');
            callback.resolve();
        });

        return callback.promise();
    }

    getContent(input) {
        let that = this,
            $input = $(input),
            titleText;
        /**
         * If info-box is set on a radio-button, the title-text of the info-box must be the text of it's parent
         * that hold the question, instead of the text of the radio-button, which is the answer to the parent question.
         * On the other hand, if the info-box is set on other fields,
         * the field itself contains the text of the question.
         */
        if (typeof $input.data('grouped') !== 'undefined') {
            titleText = $('#field-' + $input.data('grouped')).text();
        } else {
            titleText = $input.data('info-title');
        }
        let infoText = $input.data('info-teaser'),
            extendedText = $input.data('info-extended'),
            content = {
                title: '<h4>' + titleText + '</h4>',
                info: infoText,
                extended: extendedText
            },
            $content = $('<div class="dialog-content">' + content.title + that.htmlDecode(content.info) + '</div>');

        if (content.extended) {
            $content.append('<a href="#" class="info-more">' + this.options.moreLinkText + '</a><div class="info-extended">' + content.extended + '</div>');
            this.$dialog.on('click.info-more', '.info-more', function (e) {
                e.preventDefault();
                e.stopPropagation();
                that.toggleExtendedInfo();
            });
        }

        let $closeBtn = $('<a />', {
            id: 'btn-close',
            class: 'close',
            text: 'Luk',
            click: function (e) {
                e.preventDefault();
                that.hideDialog();
            }
        });
        $closeBtn.prepend('<span class="ico-delete">&times;</span>');
        $content.append($closeBtn);
        this.$dialog.addClass('has-close');


        return $content;
    }

    measureDistance(element1, element2) {
        return element1.offset().left - element2.offset().left;
    }

    getDialogPosition(callback) {
        let narrowDesignHorisontalDisplacementOfDialog = 12,
            arrowWidth = 10,
            targetOffset,
            windowWidth,
            dialogPositionX,
            dialogPositionY,
            childInput,
            position,
            canFitRightOfParentTarget,
            canFitLeftOfTarget;

        // The dialog is not wide by default, only when it is shown to the left or right of the panel
        this.$dialog.removeClass('wide');

        if (this.target.hasClass('CheckBox-more')) {
            this.target = this.target.parent();
        }


        this.target = (!this.target.is(':visible') || parseInt(this.target.css('opacity'), 10) === 0 ? this.target.next() : this.target);

        // Get metrics about the target element and the dialog,
        // to figure out how to position the dialog
        targetOffset = this.target.offset();
        windowWidth = $(window).width();
        childInput = $('#' + this.$dialog.data('target'));
        position = {};
        canFitLeftOfTarget = targetOffset.left >= this.$dialog.outerWidth();
        canFitRightOfParentTarget = (this.measureDistance(this.target, $('body')) + this.target.parent().outerWidth() + arrowWidth + this.$dialog.outerWidth()) < windowWidth;

        if (canFitLeftOfTarget) {
            // The browser window is probably wide (desktop):
            // Position the dialog LEFT of the target
            dialogPositionX = this.measureDistance(this.target, $('body')) - this.$dialog.outerWidth() - arrowWidth;
            dialogPositionY = targetOffset.top;
            this.$dialog.addClass('pos-left');
        } else if (canFitRightOfParentTarget && !this.target.is('.is-datepick')) {
            // The browser window is middle sized:
            // Position the dialog to the RIGHT of the target's parent.
            // It has to be related to the target's parent so it also works with menu checkboxes.
            dialogPositionX = this.measureDistance(this.target, $('body')) + this.target.parent().outerWidth() + arrowWidth;
            dialogPositionY = targetOffset.top;
            this.$dialog.addClass('pos-right');
        } else if (false && $('body').width() < 400) {
            // This check is disabled. But what we should do is to handle views correct according to device (retina et al)
            // The browser window is middle sized:
            // Position the dialog to the RIGHT of the target's parent.
            // It has to be related to the target's parent so it also works with menu checkboxes.
            dialogPositionX = this.measureDistance(this.target, $('body')) - this.$dialog.outerWidth() + this.$dialog.outerWidth() + narrowDesignHorisontalDisplacementOfDialog;
            dialogPositionY = targetOffset.top + 36;
            this.$dialog.addClass('pos-top');
        } else {
            // When the dialog is shown above the field, it should be wide
            this.$dialog.addClass('wide');

            // The browser window is narrow:
            // Position the dialog ABOVE the target
            dialogPositionX = this.measureDistance(this.target, $('body')) - this.$dialog.outerWidth() + this.$dialog.outerWidth() + narrowDesignHorisontalDisplacementOfDialog;
            dialogPositionY = targetOffset.top - this.$dialog.outerHeight() - 36;
            this.$dialog.addClass('pos-bottom');
        }

        // If position absolute and negative top hack is used, then add top and margin to correctly position the infobox
        if (typeof childInput !== typeof undefined && childInput !== false) {
            let childTop = parseInt(childInput.next('label').css('top'), 10),
                childMargin = parseInt(childInput.next('label').css('margin-bottom'), 10);
            if (!isNaN(childTop)) {
                dialogPositionY = dialogPositionY + childTop;
                if (!isNaN(childMargin)) {
                    dialogPositionY = dialogPositionY - childMargin;
                }
            }
        }
        position.top = dialogPositionY;
        position.left = dialogPositionX;
        this.$dialog.get(0).removeAttribute('style');
        // Add the handleViewPortHeightChange event to the resize stack
        $(window).resize(this.handleViewPortHeightChange);
        this.$dialog.css(position).fadeIn(function () {
            callback.resolve();
        });
    }

    toggleExtendedInfo() {
        let $moreLink = $('.info-more', this.$dialog);

        // The user is not currently clicking on the dialog, but on the link inside the dialog
        this.$dialog.data('clicked', false);

        // Measure the height of the extended information
        let dialogHeight = this.$dialog.outerHeight();
        $('.info-extended', this.$dialog).toggle();
        let dialogDifference = Math.abs(dialogHeight - this.$dialog.outerHeight());
        $('.info-extended', this.$dialog).toggle();

        if ($moreLink.hasClass('open')) {
            // Close the extended information
            $moreLink.removeClass('open');
            $('.info-extended', this.$dialog).slideUp('fast');
            dialogDifference = '+=' + dialogDifference;
        } else {
            // Open the extended information
            $moreLink.addClass('open');
            $('.info-extended', this.$dialog).slideDown('fast');
            dialogDifference = '-=' + dialogDifference;
        }

        // If the dialog is positioned above the field,
        // it will expand upwards when extended information is opened
        if (this.$dialog.hasClass('wide')) {
            this.$dialog.animate({ top: dialogDifference }, 'fast');
        }
    }

    htmlDecode(str) {
        let e = document.createElement('div');
        e.innerHTML = str;
        switch (e.childNodes.length) {
            case 0:
                return '';
            case 1:
                return e.childNodes[0].nodeValue;
            default:
                return e.innerHTML;
        }
    }

    permissionToHideDialog() {
        return ($('.dialog').data('forid') !== this.$dialog.data('target') && !this.$dialog.data('clicked'));
    }
}
TopdkInfodialog.DEFAULTS = {
    auto: false,
    errorStyling: false,
    moreLinkText: 'Derfor spørger vi',
    offset: {
        left: 5,
        top: 5
    }
};
plugin('topdkInfodialog', TopdkInfodialog);
